import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { WorkspaceSettings } from '../core/models/Workspace'
import type { WorkspaceChannel } from '../types/workspace'

interface WorkspaceState {
  settings: WorkspaceSettings | null
  channels: WorkspaceChannel[]
  loading: boolean
  error: string | null
}

const initialState: WorkspaceState = {
  settings: null,
  channels: [],
  loading: false,
  error: null,
}

const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<WorkspaceSettings | null>) => {
      state.settings = action.payload
    },
    setChannels: (state, action: PayloadAction<WorkspaceChannel[]>) => {
      state.channels = action.payload
    },
    addChannel: (state, action: PayloadAction<WorkspaceChannel>) => {
      state.channels.push(action.payload)
      // Sort channels by name
      state.channels.sort((a, b) => a.name.localeCompare(b.name))
    },
    updateChannel: (state, action: PayloadAction<WorkspaceChannel>) => {
      const index = state.channels.findIndex((c) => c.id === action.payload.id)
      if (index !== -1) {
        state.channels[index] = action.payload
      }
    },
    removeChannel: (state, action: PayloadAction<string>) => {
      state.channels = state.channels.filter((c) => c.id !== action.payload)
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
  },
})

export const {
  setSettings,
  setChannels,
  addChannel,
  updateChannel,
  removeChannel,
  setLoading,
  setError,
} = workspaceSlice.actions

export default workspaceSlice.reducer
